import { Rule } from 'antd/es/form';
import {
    AppDatePicker,
    AppDatePickerProps,
    AppFormItemProps,
    AppFormRangeItem,
} from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { formElementRequiredText } from 'consts/errors/forms';
import { AppFormRangeItemMode } from 'types';
import { datesTimelineValidator } from 'utils/validators';
import { commonTexts } from 'consts/text';
import { DATE_LABEL } from 'consts/labels/common';
import dayjs from 'dayjs';

export type DayPeriodPickerElementProps = Omit<AppFormItemProps, 'label'> &
    Pick<AppDatePickerProps, 'onChange'> & {
        mode: AppFormRangeItemMode;
        endField: keyof typeof formFields;
        startField: keyof typeof formFields;
        label?: string;
        minDate?: string;
        maxDate?: string;
        placeholder?: string;
        picker?: 'date' | 'week' | 'month' | 'quarter' | 'year';
        format?: string;
        isFinishValueBeforeStartValueErrorText?: string;
        isStartValueAfterFinishValueErrorText?: string;
    };

export const DayPeriodPickerElement = ({
    mode,
    startField,
    endField,
    onChange,
    label,
    minDate,
    maxDate,
    placeholder,
    picker,
    format,
    isFinishValueBeforeStartValueErrorText = commonTexts.errorMessages
        .finishDateMustBeAfterStartDate,
    isStartValueAfterFinishValueErrorText = commonTexts.errorMessages
        .startDateMustBeBeforeFinishDate,
    ...props
}: DayPeriodPickerElementProps) => {
    const rules: Rule[] = [
        props.optional ? { required: false } : { required: true, message: formElementRequiredText },
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode,
                startValueFieldName: startField,
                finishValueFieldName: endField,
                isFinishValueBeforeStartValueErrorText,
                isStartValueAfterFinishValueErrorText,
                unitToCompare: 'day',
            }),
    ];

    return (
        <AppFormRangeItem
            mode={mode}
            startValues={{
                name: startField,
                label,
                additionalText: !format ? DATE_LABEL : '',
                rules,
            }}
            finishValues={{
                name: endField,
                label,
                additionalText: !format ? DATE_LABEL : '',
                rules,
            }}
            {...props}
        >
            <AppDatePicker
                autoComplete="off"
                onChange={onChange}
                minDate={minDate ? dayjs(minDate) : undefined}
                maxDate={maxDate ? dayjs(maxDate) : undefined}
                placeholder={placeholder || 'Wybierz datę'}
                picker={picker}
                format={format}
            />
        </AppFormRangeItem>
    );
};
